import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import strings from '@/language/Swedish';
import { ResidenceType } from '@/api/mutations/useRegistrySearch';
import { RegistryColumnType } from './registryConfig';

const cellValue = (residence: ResidenceType, column: RegistryColumnType) =>
  residence[column.name] ?? '';

const exportResidencesToExcel = async (
  residences: ResidenceType[],
  columns: RegistryColumnType[],
  fileName: string
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(strings.registry.results);

  worksheet.addRow(columns.map((column) => column.label));
  residences.forEach((residence) => {
    worksheet.addRow(columns.map((column) => cellValue(residence, column)));
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
};

// Semicolon separator + BOM so the file opens correctly in Excel with Swedish locale
const escapeCsvField = (value: string | number) => {
  const text = String(value);
  return /[;"\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const exportResidencesToCsv = (
  residences: ResidenceType[],
  columns: RegistryColumnType[],
  fileName: string
) => {
  const rows = [
    columns.map((column) => escapeCsvField(column.label)).join(';'),
    ...residences.map((residence) =>
      columns
        .map((column) => escapeCsvField(cellValue(residence, column)))
        .join(';')
    ),
  ];

  const blob = new Blob(['\uFEFF' + rows.join('\r\n')], {
    type: 'text/csv;charset=utf-8',
  });
  saveAs(blob, `${fileName}.csv`);
};

export { exportResidencesToExcel, exportResidencesToCsv };
